import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { matchesRegisterRead, registerKey } from '../lessonRegisterReadModel';

const lessonRegisterReducer = (state = initialState.lessonRegister, action) => {
  switch (action.type) {
    case types.CREATE_LESSON_REGISTER_SUCCESS:
    case types.UPDATE_LESSON_REGISTER_SUCCESS:
      return state.some(record => registerKey(record) === registerKey(action.lessonRegister))
        ? state.map(record => (registerKey(record) === registerKey(action.lessonRegister) ? action.lessonRegister : record))
        : [...state, { ...action.lessonRegister }];
    case types.LOAD_LESSON_REGISTER_SLICE_SUCCESS: {
      const preserved = new Set(action.preserveKeys);
      const incoming = action.lessonRegisters.filter(record => !preserved.has(registerKey(record)));
      const replaced = new Set(incoming.map(registerKey));
      return [...state.filter(record => preserved.has(registerKey(record)) ||
        (!matchesRegisterRead(record, action.query) && !replaced.has(registerKey(record)))), ...incoming];
    }
    case types.LOAD_LESSON_REGISTER_SUCCESS:
      return action.lessonRegisters;
    case types.DELETE_LESSON_REGISTER_OPTIMISTIC:
      return state.filter(lessonRegister => lessonRegister.id !== action.lessonRegister.id);
    default:
      return state;
  }
};

export default lessonRegisterReducer;
